/**
 * Icon keys the server may name, and the component each one draws.
 *
 * The server sends a key, never a component, so a tenant's sidebar can be
 * edited without a frontend release. Keep this list the same as ICONS in
 * backend/services/navigation/schema.py — the backend test
 * `test_every_icon_key_is_known_to_the_frontend` checks it. A key missing here
 * falls back to a plain dot rather than breaking the row.
 */
import type { SvgIconComponent } from '@mui/icons-material';
import AccountTreeRounded from '@mui/icons-material/AccountTreeRounded';
import AssignmentRounded from '@mui/icons-material/AssignmentRounded';
import AutoAwesomeRounded from '@mui/icons-material/AutoAwesomeRounded';
import CableRounded from '@mui/icons-material/CableRounded';
import CampaignRounded from '@mui/icons-material/CampaignRounded';
import ChatBubbleOutlineRounded from '@mui/icons-material/ChatBubbleOutlineRounded';
import CircleRounded from '@mui/icons-material/CircleRounded';
import DashboardRounded from '@mui/icons-material/DashboardRounded';
import EventNoteRounded from '@mui/icons-material/EventNoteRounded';
import FlightTakeoffRounded from '@mui/icons-material/FlightTakeoffRounded';
import LeaderboardRounded from '@mui/icons-material/LeaderboardRounded';
import MenuBookRounded from '@mui/icons-material/MenuBookRounded';
import ModelTrainingRounded from '@mui/icons-material/ModelTrainingRounded';
import PeopleRounded from '@mui/icons-material/PeopleRounded';
import PhoneInTalkRounded from '@mui/icons-material/PhoneInTalkRounded';
import SettingsRounded from '@mui/icons-material/SettingsRounded';
import SmartToyOutlined from '@mui/icons-material/SmartToyOutlined';
import SummarizeRounded from '@mui/icons-material/SummarizeRounded';
import TimelineRounded from '@mui/icons-material/TimelineRounded';
import TrendingUpRounded from '@mui/icons-material/TrendingUpRounded';
import TuneRounded from '@mui/icons-material/TuneRounded';

export const NAV_ICONS: Record<string, SvgIconComponent> = {
  'copilot': ChatBubbleOutlineRounded,
  'agents': SmartToyOutlined,
  'dashboard': DashboardRounded,
  'spaces': MenuBookRounded,
  'phone': PhoneInTalkRounded,
  'timeline': TimelineRounded,
  'flight': FlightTakeoffRounded,
  'connectors': CableRounded,
  'data-model': AccountTreeRounded,
  'knowledge': AutoAwesomeRounded,
  'model': ModelTrainingRounded,
  'settings': SettingsRounded,
  'people': PeopleRounded,
  'sales': TrendingUpRounded,
  'marketing': CampaignRounded,
  'new-business': AssignmentRounded,
  'scorecard': LeaderboardRounded,
  'simulator': TuneRounded,
  'report': SummarizeRounded,
  'planner': EventNoteRounded,
};

export function navIcon(key: string | undefined): SvgIconComponent {
  return (key && NAV_ICONS[key]) || CircleRounded;
}
